import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { MatTableDataSource } from '@angular/material/table';
import { ParentChildrenService } from 'src/app/services/parent-children.service';
import { childInfo } from 'src/app/constants/constants';

@Component({
  selector: 'app-student-classes',
  templateUrl: './student-classes.component.html',
  styleUrls: ['./student-classes.component.scss'],
})
export class StudentClassesComponent implements OnInit {
  role = localStorage['roleId'];
  private readonly notifier: NotifierService;
  student_classes = [];
  selectedChild: childInfo = {
    zipcode: '',
    country: '',
    skype: '',
    haveAcademicCoaching: false,
    address: '',
    gender: 0,
    mobile: '',
    last_name: '',
    student_id: 0,
    first_name: '',
    haveTestPrep: false,
    email: ''
  };

  constructor(
    private httpClient: HttpClient,
    notifierService: NotifierService,
    private parentChildrenService: ParentChildrenService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.selectedChild = this.parentChildrenService.getSelectedChild()
    let userId =
      localStorage['roleId'] == 4
        ? this.selectedChild.student_id
        : localStorage['userId'];
    console.log(userId);
    this.httpClient
      .get('/api/get_student_classes?studentId=' + userId, {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken'],
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response);
          this.student_classes = JSON.parse(response['data']);
        },
        (error) => {
          console.log(error);
          this.notifier.notify(
            'error',
            'Unable to fetch student class details'
          );
        }
      );
  }

  openZoom(url: string) {
    window.open(url, '_blank');
  }
}
